import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useMainContext } from "../../../Context";
import { useQuery } from "../../../Hooks";
import {
  createAds,
  nesdata,
  updateAds,
  adsShow,
  listAds,
  payOrPulished,
  checkOffer
} from "../../../Utils/Apis";
export const useCreateAds = () => {
  const [form, setForm] = useState({
    show: false,
    selected: {},
    step: "selectCategory",
    location: "36.258241314877736,58.83325211656804",
    id: 1,
    type: "personal",
    option: [],
  });
  const [loadingCheck, setLoadingCheck] = useState(false);
  const navigate = useNavigate();
  const [init, setInint] = useState({});
  const [loading, setLoading] = useState({ get: true, show: true });
  const {
    post,
    state: { user },
  } = useMainContext();
  
  const { changeObj, searchParams, getValue } = useQuery({
    filters: [{ key: "ads_id" }],
  });
  const handler = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  const value = key => {
    return key ? form[key] || "" : "";
  };
  const getCategory = async () => {
    setLoading({ get: true });
    const { data, status } = await post(nesdata, {
      needkey: ["categories", "options"],
    });
    setInint(data);
    setLoading({ get: false });
  };
  const store = async () => {
    setLoading({ step1: true });
    const { data, status } = await post(
      createAds,
      {
        ...form,
      },
      true
    );
    if (+status === 200) {
      changeObj("ads_id", data.id);
      setForm({ ...form, ...data, step: 2 });
    }
    else {
      toast.error("لطفا مشخصات را کامل ثبت کنید");
    }
    setLoading({ step1: false });
  };
  const edit = async () => {
    if (!checkStep()) {
      return
    }

    setLoading({ edit: true });
    const { data, status } = await post(updateAds, {
      ...form,
      id: searchParams.get("ads_id"),
    });
    if (+status == 200) {
      if (data.ads) {
        setForm({
          ...form,
          step: +form.step + 1,
          ...data.ads,
          category_price: data.category_price,
        });
      }
      else {
        toast.error("لطفا مشخصات را کامل پر کنید");
      }
    }
    setLoading({ edit: false });
  };

  const checkStep = () => {
    if (form.step == 2) {
      if (!form.province_id || !form.province_id || !form.addres) {
        toast.error("لطفا مشخصات مکانی را کامل ثبت کنید");
        return false;
      }
    }
    else if (form.step == 3) {
      if (!form.main_image) {
        toast.error("لطفا عکس اصلی را انتخاب کنید");
        return false;
      }
    }
    else if (form.step == 4) {
      if (form.type == "personal") {
        if (!form.fullname || !form.mobile || !form.email) {
          toast.error("لطفا اطلاعات تماس را کامل ثبت کنید");
          return false;
        }
      }
      else if (form.type == "company") {
        if (!form.co_addres || !form.co_mobile
          || !form.co_name || !form.co_tell) {
          toast.error("لطفا اطلاعات تماس را کامل ثبت کنید");
          return false;
        }
      }
    }

    return true;
  }

  const publised = async () => {
    setLoading({ published: true });
    const { data, status } = await post(
      payOrPulished,
      {
        ...form,
        id: searchParams.get("ads_id"),
      },
      true
    );
    if (+status == 200) {
      if (data.need_pey === "true") {
        window.location.replace(data.url);
      } else {
        return navigate("/my-ads");
      }
    }
    setLoading({ edit: false });
  };


  const show = async () => {
    setLoading({ ...loading, show: false });
    const { data, status } = await post(adsShow, {
      id: searchParams.get("ads_id"),
    });
    if (+status == 200) {
      setForm({ ...form, ...data, keywords: data.keywords || [] });
    }
  };
  useEffect(() => {
    if (searchParams.get("ads_id")) {
      show();
    }
  }, [searchParams]);

  useEffect(() => {
    getCategory();
  }, []);
  const renderTotoalPrice = (options = []) => {
    let res = 0;
    if (form.option && Array.isArray(form.option)) {
      options.map(op => {
        if (form.option.includes(op.id)) {
          res += +op.price;
        }
      });
    }
    return res;
  };
  const stepHandler = () => {
    switch (form.step) {
      case "selectCategory":
        return "1- انتخاب دسته بندی";
        break;
      case 1:
        return "2- مشخصات کلی";
      case 2:
        return "3- مشخصات مکانی";
      case 3:
        return "4- تصاویر";
      case 4:
        return "5- اطلاعات تماس";
      case 5:
        return "5- ثبت آگهی";

      default:
        break;
    }
  };

  const prevStep = () => {
    setLoading({ edit: true });

    setForm({
      ...form,
      step: +form.step - 1
    });

    setLoading({ edit: false });
  }

  const check = async init => {
    setLoadingCheck(true);
    const { data, status } = await post(
      checkOffer,
      {
        options: form.option,
        ads_id: searchParams.get("ads_id"),
        off_code: form.off_code,
      },
      true
    );
    setForm({ ...form, ...data, status: true });
    setLoadingCheck(false);
  };

  return {
    form,
    getCategory,
    init,
    loading,
    handler,
    store,
    edit,
    publised,
    value,
    stepHandler,
    setForm,
    user,
    searchParams,
    renderTotoalPrice,
    getValue,
    changeObj,
    prevStep,
    loadingCheck,
    check
  };
};
export const useListAds = () => {
  const [loading, setLoading] = useState(true);
  const [nextLoading, setNextLoading] = useState(false);
  const [data, setData] = useState({});
  const { post } = useMainContext();
  const navigate = useNavigate();
  const { searchParams, createObjFilter } = useQuery({});
  const get = async () => {
    setLoading(true);
    const { data } = await post(listAds, { ...createObjFilter() });
    setData(data);
    setLoading(false);
  };

  const getNext = async (url) => {
    setNextLoading(true);
    const { data: result } = await post(url, { ...createObjFilter() });

    const newData = {
      ...data,
      data: data.data.concat(result.data),
      next_page_url: result.next_page_url
    }

    setData(newData);
    setNextLoading(false);
  };

  const renderstatus = status => {
    switch (status) {
      case "draft":
        return {
          title: "پیش نویس",
          status: "process",
        };
      case "peyerror":
      case "waittopey":
        return {
          title: "عدم پرداخت",
          status: "error",
        };
      case "inprocess":
        return {
          title: "در حال بررسی اولیه",
          status: "process",
        };
      case "visible":
        return {
          title: "منتشر شده",
          status: "success",
        };
      case "hidden":
        return {
          title: "غیر فعال",
          status: "error",
        };
      case "reject":
        return {
          title: "رد شده",
          status: "error",
        };
      case "edited":
        return {
          title: "منتظر بررسی مجدد",
          status: "process",
        };
    }
    return {};
  };
  useEffect(() => {
    get();
  }, [searchParams]);

  return {
    loading,
    data,
    searchParams,
    navigate,
    renderstatus,
    getNext,
    setLoading,
    setData,
    nextLoading
  };
};
export const useSingle = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState({ show: true });
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    post,
    state: { user },
  } = useMainContext();

  const show = async () => {
    setLoading({ show: true });
    const { data } = await post(adsShow, { id });
    setForm({ ...data, type: data.type || "personal" });
    setLoading({ show: false });
  };

  useEffect(() => {
    show();
  }, []);
  const renderStatus = status => {
    switch (status) {
      case "draft":
        return {
          title: "پیش نویس",
          status: "process",
          edit: true,
        };
      case "peyerror":
        return {
          title: "عدم پرداخت",
          edit: false,
          status: "error",
        };
      case "inprocess":
        return {
          title: "در حال بررسی اولیه",
          edit: false,
          status: "process",
        };
      case "visible":
        return {
          title: "منتشر شده",
          status: "success",
          edit: true,
        };
      case "hidden":
        return {
          title: "غیر فعال",
          status: "error",
          edit: false,
        };
      case "reject":
        return {
          title: "رد شده",
          status: "error",
          edit: true,
        };
    }
    return {};
  };
  const handler = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  const value = key => {
    return key ? form[key] || "" : "";
  };

  const publishHandler = async () => {
    setLoading({ ...loading, publish: true });
    const { status, data } = await post(payOrPulished, { ...form }, true);
    setForm({ ...form, ...data, type: data.type || "personal" });
    setLoading({ ...loading, publish: false });
  };

  return {
    navigate,
    form,
    setForm,
    loading,
    renderStatus,
    user,
    handler,
    value,
    publishHandler
  };
};
